import { NgModule } from '@angular/core';
import { GenericComponent } from './generic.component';
import { GenericService } from './generic.service';
import { GenericRoutingModule } from './generic-routing.module';
import { SharedModule } from '../shared/shared.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  imports: [GenericRoutingModule, SharedModule, MatTabsModule, MatPaginatorModule],
  declarations: [GenericComponent],
  exports: [GenericComponent],
  providers: [GenericService]
})
export class GenericModule { }
